import $ from "jquery";

import Field from "./../field";
import Dropdown from "./dropdown";

const Baths = (($) => {
  const OptionList = [
    { value: "1" },
    { value: "1.5" },
    { value: "2" },
    { value: "2.5" },
    { value: "3" },
    { value: "3.5" },
    { value: "4" },
    { value: "4.5" },
    { value: "5" },
    { value: "5.5" },
    { value: "6" },
    { value: "6.5" },
    { value: "7" },
    { value: "7.5" },
    { value: "8" },
    { value: "8.5" },
    { value: "9" },
    { value: "9.5" },
    { value: "10" },
  ];

  return (field) => {
    return new Dropdown({ ...field, options: OptionList });
  };
})($);

export default Baths;
